import { render, staticRenderFns } from "./104.vue?vue&type=template&id=821a94ec&scoped=true&"
var script = {}
import style0 from "./104.vue?vue&type=style&index=0&id=821a94ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821a94ec",
  null
  
)

export default component.exports